// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"1672a2f3","51":"49d56517","52":"44c47798","97":"bf951e11","175":"4877a226","237":"278a84d2","323":"fa0d87f7","342":"951cf8e5","489":"81a3a499","630":"6674a4b5","744":"21dc2151","849":"15b3ae20","856":"b699323d","954":"0f2afafe"}[chunkId] + ".chunk.js";
};